import { render, staticRenderFns } from "./RushRacePlayerInfo.vue?vue&type=template&id=ad0f836c&"
import script from "./RushRacePlayerInfo.vue?vue&type=script&lang=js&"
export * from "./RushRacePlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports